var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-device-setting-component" },
    [
      _c(
        "div",
        { staticClass: "modal-device-setting" },
        [
          _vm.isDevicetest
            ? _c(_vm.infoComponent, {
                ref: "deviceInfo",
                tag: "component",
                attrs: { roomInfo: _vm.roomInfo, isShowInfo: _vm.isShowInfo },
                on: {
                  "update:isShowInfo": function ($event) {
                    _vm.isShowInfo = $event
                  },
                  "update:is-show-info": function ($event) {
                    _vm.isShowInfo = $event
                  },
                  reqJoin: _vm.reqJoin,
                  reqApproveJoin: _vm.reqApproveJoin,
                },
              })
            : _vm._e(),
          _c("DeviceSettingPreview", {
            ref: "devicePreview",
            attrs: {
              roomInfo: _vm.roomInfo,
              isShowCoachmark: _vm.isShowCoachmark,
              isDevicetest: _vm.isDevicetest,
            },
            on: {
              onToggleInfo: _vm.toggleInfo,
              reqJoin: _vm.reqJoin,
              reqApproveJoin: _vm.reqApproveJoin,
              onUpdatePreview: _vm.onUpdatePreview,
            },
          }),
        ],
        1
      ),
      _vm.isShowCoachmark
        ? _c("ModalDeviceSettingCoachmark", {
            attrs: { isShowCoachmark: _vm.isShowCoachmark },
            on: {
              "update:isShowCoachmark": function ($event) {
                _vm.isShowCoachmark = $event
              },
              "update:is-show-coachmark": function ($event) {
                _vm.isShowCoachmark = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }